module.exports = __webpack_public_path__ + "img/product_124.6fefd39.svg";